import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Star, Trash2 } from "lucide-react";

export default function AdminReviews() {
  const [items, setItems] = useState([]);

  const load = () => api.get("/admin/reviews").then(({ data }) => setItems(data.items || []));
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    if (!window.confirm("Delete this review? The company's aggregate rating will be recomputed.")) return;
    await api.delete(`/admin/reviews/${id}`);
    toast.success("Review deleted");
    load();
  };

  return (
    <div>
      <div className="overline text-safety">Reviews</div>
      <h1 className="mt-1 font-display font-black text-3xl tracking-tighter text-forest">Review moderation</h1>

      <div className="mt-6 border border-border bg-white">
        {items.length === 0 ? (
          <div className="p-10 text-center text-sm text-muted-foreground">No reviews yet.</div>
        ) : items.map((r, i) => (
          <div key={r.review_id} data-testid={`admin-review-row-${r.review_id}`} className={`p-5 grid grid-cols-1 md:grid-cols-[1fr,auto] gap-4 items-start ${i > 0 ? "border-t border-border" : ""}`}>
            <div>
              <div className="flex items-center gap-1 mb-1">
                {[1,2,3,4,5].map((n) => <Star key={n} className={`w-4 h-4 ${n <= r.rating ? "fill-safety text-safety" : "text-muted-foreground"}`} />)}
                <span className="overline text-[10px] text-muted-foreground ml-2">{new Date(r.created_at).toLocaleDateString("en-GB")}</span>
              </div>
              <div className="text-sm">{r.comment || <span className="text-muted-foreground">(no comment)</span>}</div>
              <div className="text-xs text-muted-foreground mt-1">{r.user_name} → company {r.company_id}</div>
            </div>
            <Button onClick={() => del(r.review_id)} size="sm" variant="outline" data-testid={`admin-review-delete-${r.review_id}`} className="rounded-none border-destructive text-destructive hover:bg-destructive hover:text-white">
              <Trash2 className="w-4 h-4" />
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
